export default __webpack_public_path__ + "static/media/Burundi.e0593d64.png";